import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { DynamicModuleLoader } from 'redux-dynamic-modules-react';
import getRootModule from 'RootModule';
import getBaseInformationMassiveUploadModule from '../getBaseInformationMassiveUploadModule';
import { layoutContext } from 'context';
import { useHistory } from 'react-router-dom';
import { Form } from 'antd';
import { UploadExcelButton, ActionButtonsExcelUpload } from 'common/MassiveUploads/components';
import MassiveUploadTable from '../components/MassiveUploadTable';
import { triggerModalForDuplicates } from 'common/MassiveUploads/utils';
//cambiar sagas
import {
  BaseInformationMassiveUploadSetAllowUpload,
  BaseInformationMassiveUploadRequestVerify,
  BaseInformationMassiveUploadRequestUpload,
  BaseInformationMassiveUploadClearUpload,
  BaseInformationMassiveUploadClearVerify,
  BaseInformationMassiveUploadClearAllowUpload,
  ExistsStatements,
} from '../redux-saga/actions';

const BaseInformationMassiveUpload = (props) => {
  const {
    BaseInformationMassiveUploadSetAllowUpload: setAllowUpload,
    BaseInformationMassiveUploadRequestVerify: requestVerify,
    BaseInformationMassiveUploadRequestUpload: requestUpload,
    BaseInformationMassiveUploadClearUpload: clearUpload,
    BaseInformationMassiveUploadClearVerify: clearVerify,
    BaseInformationMassiveUploadClearAllowUpload: clearAllowUpload,
    ExistsStatements: ExistsStatementsGet,
    allowUpload,
    verify,
  } = props;

  const history = useHistory();
  const [form] = Form.useForm();
  const { onChangeActiveComponent } = useContext(layoutContext);
  const [fileString, setFileString] = useState('');
  const correct = verify?.correct;
  const entriesList = verify?.objectList;
  const totalDuplicatedEntries = verify?.replaced?.length;
  const allCorrectMessage = verify?.allCorrectMessage;

  useEffect(() => {
    clearAllowUpload();
    ExistsStatementsGet({ history });
    return () => {
      clearAllowUpload();
      clearUpload();
      clearVerify();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    onChangeActiveComponent('activo');
    if (correct > 0) {
      setAllowUpload(true);
    } else {
      setAllowUpload(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [correct]);

  function customRequest({ file }) {
    requestVerify({ file, setFileString });
  }
  function requestReplace() {
    requestUpload({ history, fileString, overwrite: true });
  }
  function requestKeep() {
    requestUpload({ history, fileString, overwrite: false });
  }

  function onSubmit() {
    if (totalDuplicatedEntries > 0) {
      triggerModalForDuplicates(totalDuplicatedEntries, requestReplace, requestKeep, 'Compras');
      return;
    }
    requestReplace();
  }
  function onCancel() {
    history.push(`/account-status/base-information`);
  }

  return (
    <Form form={form}>
      <UploadExcelButton customRequest={customRequest} />
      <MassiveUploadTable data={entriesList} allCorrectMessage={allCorrectMessage} />
      <ActionButtonsExcelUpload
        onSubmit={onSubmit}
        onCancel={onCancel}
        disabled={!allowUpload}
        buttons={['cancel', 'submit']}
      />
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    allowUpload: state?.Dynamic_MASSIVE_UPLOAD?.allowUpload,
    verify: state?.Dynamic_MASSIVE_UPLOAD?.verify,
  };
};

const ConnectedBaseInformationMassiveUpload = connect(mapStateToProps, {
  BaseInformationMassiveUploadSetAllowUpload,
  BaseInformationMassiveUploadRequestVerify,
  BaseInformationMassiveUploadRequestUpload,
  BaseInformationMassiveUploadClearUpload,
  BaseInformationMassiveUploadClearVerify,
  BaseInformationMassiveUploadClearAllowUpload,
  ExistsStatements,
})(BaseInformationMassiveUpload);

const BaseInformationMassiveUploadWithModules = () => {
  return (
    <DynamicModuleLoader modules={[getRootModule(), getBaseInformationMassiveUploadModule()]}>
      <ConnectedBaseInformationMassiveUpload />
    </DynamicModuleLoader>
  );
};
export default BaseInformationMassiveUploadWithModules;
